import useSearchObjects from "backend/hooks/elements/useSearchObjects";
import { ICardElementWithChildren } from "backend/model/model";
import SearchBarDesign from "design/components/search/SearchBar";
import SearchResultRow from "design/components/search/SearchResultRow";
import * as conf from "qpr-base/configuration";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import React from "react";
import typeToView from "routing/typetoview";

const SearchUsing = (
  keys: Array<keyof ICardElementWithChildren>,
  v: ICardElementWithChildren,
  searchKey: string
) => {
  let found = false;
  keys.forEach((k) => {
    if (typeof v[k] === "string") {
      if (
        v[k]
          ?.toString()
          .toLocaleLowerCase()
          .includes(searchKey.toLocaleLowerCase())
      ) {
        found = true;
      }
    }
  });
  return found;
};

const Search = () => {
  const link = useLink();
  const ctx = useAppContext();
  const { data, isLoading } = useSearchObjects([
    "KPI",
    "Initiative",
    "Strategic Objective",
  ]);
  const [results, setResults] = React.useState<
    ICardElementWithChildren[] | undefined
  >();
  const [searchCandidate, setSearchCandidate] = React.useState("");
  const [hasSearch, setHasSearch] = React.useState("");

  React.useEffect(() => {
    if (data && !isLoading && searchCandidate.length > 0) {
      let res: ICardElementWithChildren[] = data;
      searchCandidate
        .split(" ")
        .filter((v) => v)
        .forEach((searchKey) => {
          res = res
            .filter(
              (v) =>
                typeToView(v.typename) &&
                !v.scorecardname?.includes("_config") &&
                !v.symbol?.includes("D0")
            )
            .filter((v) =>
              SearchUsing(
                [
                  "name",
                  "rangename",
                  "periodlevelname",
                  "description",
                  "name",
                  "typename",
                  "scorecardname",
                  "scorecardsymbol",
                ],
                v,
                searchKey
              )
            );
        });
      setResults(res);
    }
  }, [data, searchCandidate, isLoading, ctx.modelId]);

  const getRangeColor = (
    element: ICardElementWithChildren
  ): string | undefined => {
    const settings =
      element.typename === "KPI"
        ? conf.getKPIsViewGaugeSettings(element)
        : conf.getInitiativeDetailsViewGaugeSettings(element);
    if (!!settings.colorAttribute)
      return element[
        settings.colorAttribute as keyof ICardElementWithChildren
      ] as string;
    return element["rangecolor"];
  };

  return (
    <div>
      <SearchBarDesign
        maxResults={1000}
        results={results}
        RenderRow={(props) => {
          const item = { ...props.value };
          if (item.typename === "KPI") {
            item.PERF_prettyvalue = item.PERF_YTD_prettyvalue;
            item.rangecolor = getRangeColor(item);
          }
          if (item.typename === "Initiative") {
            item.PERF_prettyvalue = item.COMPLETION_PERCENTAGE_prettyvalue;
            item.rangecolor = getRangeColor(item);
          }
          return <SearchResultRow value={item} onNavigate={props.onNavigate} />;
        }}
        isLoading={isLoading}
        onNavigate={(value) => {
          link({
            page: typeToView(value.typename),
            meaId: value.id,
          });
        }}
        onSearch={(value) => {
          setSearchCandidate(value);
        }}
      />
    </div>
  );
};

export default Search;
